
import { useEffect, useState } from "react"
import PageTitle from "../../../components/PageTitle"
import api from "../../../services/api";
import Spinner from "../../../shared/Spinner/Spinner";
import Style from "./RatingsStyle"

interface Rating {
    success: boolean,
    npsRating: number,
    promoters: number,
    detractors: number,
    passives: number
}

export default function Ratings(props) {
    
    const [ratings, setRatings] = useState<Rating>({} as Rating);
    const [loading, setLoading] = useState(false);
    const [promoterRate, setPromoterRate] = useState(0);
    const [detractorRate, setDetractorRate] = useState(0);
    const [passiveRate, setPassiveRate] = useState(0);
    const [totalRatings, setTotalRatings] = useState(0);

    useEffect(() => {
        GetNPS()
    }, [])

    async function GetNPS() {
        try {
            setLoading(true)
            const result = await api.get<Rating>(`enterprises/${props.match.params.enterpriseId}/nps`)
            setRatings(result.data)
            setTotalRatings(ratings.promoters + ratings.detractors + ratings.passives)
            CalculateRates()
            setLoading(false)
        }
        catch {
            console.log("Erro")
        }
    }

    function CalculateRates() {
        setPromoterRate(totalRatings !== 0 ? (ratings.promoters / totalRatings)*100 : 0);
        setDetractorRate(totalRatings !== 0 ? (ratings.detractors / totalRatings)*100 : 0);
        setPassiveRate(totalRatings !== 0 ? (ratings.passives / totalRatings)*100 : 0);
    }
    

    return(
        <Style className="default-page">
            <PageTitle title="Avaliações do empreendimento" />
            <div>
                <button onClick={() => props.history.goBack()} className=" btn-secondary">Voltar</button>
            </div>
            <Spinner spinning={loading} />
            <main className="default-main">
                <div className="panel">
                    <form className="main-form">
                        <h1>Avaliações</h1>
                        <div>
                            <label>NPS: </label>
                            <span>
                                {!loading ? ratings.npsRating * 100 : ""}
                            </span>
                        </div>
                        <div>
                            <label>Qtd Promotores: </label>
                            <span>
                                {!loading ? ratings.promoters : ""}
                            </span>
                        </div>
                        <div>
                            <label>Qtd Detratores: </label>
                            <span>
                                {!loading ? ratings.detractors : ""}
                            </span>
                        </div>
                        <div>
                            <label>Qtd Passivos: </label>
                            <span>
                                {!loading ? ratings.passives : ""}
                            </span>
                        </div>
                        <div>
                            <label>% Promotores: </label>
                            <span>
                                {!loading ? promoterRate + "%" : ""}
                            </span>
                        </div>
                        <div>
                            <label>% Detratores: </label>
                            <span>
                                {!loading ? detractorRate + "%" : ""}
                            </span>
                        </div>
                        <div>
                            <label>% Passivos: </label>
                            <span>
                                {!loading ? passiveRate + "%" : ""}
                            </span>
                        </div>
                    </form>
                </div>
            </main>
        </Style>
    )
}
